import styled from 'styled-components'

import { getToken } from '@helpscout/hsds-tokens/getToken'

import { getColor } from 'hsds/utils/color'

import {
  STATUS_ERROR,
  STATUS_SUCCESS,
  STATUS_WARNING,
} from '../../Noty.constants'
import NotyButton from '../NotyButton'
import Icon from 'hsds/components/icon'

export const NotyEmphasisUI = styled.span`
  font-weight: bold;
`

export const NotyButtonUI = styled(NotyButton)`
  margin-left: 10px;
  & + & {
    margin-left: 2px;
  }

  &.is-refresh-for-updates-noty {
    flex: inherit;
  }
`

export const IconUI = styled(Icon)`
  border-radius: 100px;
  color: white;
  margin-right: 10px;
  flex: 0 0 24px;
  height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  background-color: var(--NotyIconColor);
`

export const NotyElementUI = styled.div`
  --NotyBackgroundColor: ${getColor('state.info.backgroundLight')};
  --NotyBorderColor: ${getColor('state.info.borderColor')};
  --NotyTextColor: ${getColor('state.info.text')};
  --NotyIconColor: ${getColor('state.info.icon')};

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-10px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  box-shadow: 0px 2px 8px 0px #0000000a, 0px 5px 8px 0px #63748608;

  animation: fadeIn 0.15s;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 20px;
  flex: 1 0 auto;
  min-height: 52px;
  max-width: 75vw;

  background-color: var(--NotyBackgroundColor);
  border: 1px solid var(--NotyBorderColor);
  color: var(--NotyTextColor);
  border-radius: ${getToken('radius.overlay')};
  margin-bottom: 10px;

  transition: 0.15s ease-in-out opacity,
    0.25s cubic-bezier(0.77, 0, 0.175, 1) transform;
  opacity: 0;

  position: absolute;
  transform: translateY(-20px);
  overflow: hidden;
  font-size: 14px;
  line-height: 17px;

  &:hover {
    cursor: pointer;
  }

  .c-Icon__icon {
    width: 100%;
  }

  b,
  strong,
  ${NotyEmphasisUI} {
    font-weight: 500;
  }

  &.is-${STATUS_SUCCESS} {
    --NotyBackgroundColor: ${getColor('state.success.backgroundLight')};
    --NotyBorderColor: ${getColor('state.success.borderColor')};
    --NotyTextColor: ${getColor('state.success.text')};
    --NotyIconColor: ${getColor('state.success.icon')};
  }

  &.is-${STATUS_ERROR} {
    --NotyBackgroundColor: white;
    --NotyBorderColor: ${getColor('state.error.borderColor')};
    --NotyTextColor: ${getColor('state.error.text')};
    --NotyIconColor: ${getColor('state.error.icon')};

    // getColor('state.error.backgroundLight') is transparent let's put a white bg behind it
    &:before {
      content: '';
      display: block;
      position: absolute;
      background: ${getColor('state.error.backgroundLight')};
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  &.is-${STATUS_WARNING} {
    --NotyBackgroundColor: ${getColor('state.warning.backgroundLight')};
    --NotyBorderColor: ${getColor('state.warning.borderColor')};
    --NotyTextColor: ${getColor('state.warning.text')};
    --NotyIconColor: ${getColor('state.warning.icon')};
  }

  &.is-visible {
    opacity: 1;
    transform: translateY(0);
  }
`

export const NotyContentUI = styled.div`
  flex: 1 1 100%;
  margin: 15px 0;
  position: relative;
`
